import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Check, Star, Eye, BarChart3, Zap } from "lucide-react";

const FEATURES = [
  { icon: Eye, label: "Important Info", desc: "Access daily Important Info overlays for every hour" },
  { icon: BarChart3, label: "Business", desc: "Business category analysis & predictions", color: "#3b82f6" },
  { icon: Star, label: "Wealth", desc: "Wealth category analysis & predictions", color: "#f59e0b" },
  { icon: Zap, label: "Career", desc: "Career category analysis & predictions", color: "#8b5cf6" },
  { icon: Check, label: "Health", desc: "Health category analysis & predictions", color: "#10b981" },
  { icon: Check, label: "Academics", desc: "Academics category analysis & predictions", color: "#06b6d4" },
  { icon: Check, label: "Relationships", desc: "Relationships category analysis & predictions", color: "#ec4899" },
  { icon: Check, label: "Recognition", desc: "Recognition category analysis & predictions", color: "#f97316" },
];

export default function PricingPage() {
  const navigate = useNavigate();

  return (
    <div className="pricing-page" data-testid="pricing-page">
      <header className="pricing-header">
        <button className="pricing-back" onClick={() => navigate("/")} data-testid="pricing-back-btn">
          <ArrowLeft size={18} />
          <span>Back</span>
        </button>
        <h1 className="pricing-title">Unlock Full Access</h1>
        <p className="pricing-subtitle">
          Get the complete Qi Men Dun Jia experience with all forecast categories and Important Info
        </p>
      </header>

      <main className="pricing-main">
        <div className="pricing-card" data-testid="pricing-card">
          <div className="pricing-card-badge">FULL ACCESS</div>
          <div className="pricing-amount">
            <span className="pricing-currency">USD</span>
            <span className="pricing-value">47</span>
            <span className="pricing-period">/month</span>
          </div>

          <div className="pricing-features">
            {FEATURES.map((f, i) => (
              <div key={i} className="pricing-feature" data-testid={`pricing-feature-${i}`}>
                <div className="pricing-feature-icon" style={f.color ? { color: f.color } : {}}>
                  <f.icon size={18} />
                </div>
                <div className="pricing-feature-text">
                  <span className="pricing-feature-label">{f.label}</span>
                  <span className="pricing-feature-desc">{f.desc}</span>
                </div>
              </div>
            ))}
          </div>

          <Button className="pricing-cta" data-testid="pricing-cta-btn" onClick={() => {}}>
            Subscribe Now
          </Button>
          <p className="pricing-note">Full access to all features. Cancel anytime.</p>
        </div>
      </main>

      <footer className="pricing-footer">
        <p className="footer-copyright">Copyright &copy; 2026 Steven Yong - Digital Dive Coaching Sdn. Bhd. All rights reserved worldwide.</p>
      </footer>
    </div>
  );
}
